import { Box, Grid, Toolbar } from '@mui/material';
import React, { ReactNode } from 'react';
// eslint-disable-next-line import/prefer-default-export
export function PageContainer({
  children,
  addedStyle,
  onScroll,
}: {
  children: ReactNode;
  addedStyle?: React.CSSProperties;
  onScroll?: () => void | undefined;
}) {
  return (
    <Box
      sx={{
        backgroundColor: 'white',
        contain: 'content',
        paddingTop: '20px',
        paddingLeft: { xs: 0, sm: '20px' },
        paddingRight: { xs: 0, sm: '20px' },
        paddingBottom: '100px',
        '& button': {
          '& .MuiButton-containedSizeSmall': {
            height: '3rem',
            width: { xs: '100%', sm: '40%' },
          },
        },
        margin: { xs: '0 8px', sm: 0 },
      }}
      style={{ ...addedStyle }}
      onScroll={onScroll}
    >
      <Toolbar />

      {children}
    </Box>
  );
}

PageContainer.defaultProps = { addedStyle: {}, onScroll: () => undefined };

interface FormContainerProps {
  children: React.ReactNode;
  addedStyle?: React.CSSProperties;
  onSubmit?: (event: React.SyntheticEvent) => Promise<void> | void;
}

export function FormContainer({ children, addedStyle, onSubmit }: FormContainerProps) {
  return (
    <form style={{ ...addedStyle, width: '100%' }} onSubmit={onSubmit}>
      <Grid
        container
        direction='row'
        justifyContent='center'
        alignContent='center'
        spacing={2}
        sx={{
          marginTop: '8px',
          '& .MuiFormControl-root': {
            width: '100%',
          },
        }}
      >
        {children}
      </Grid>
    </form>
  );
}

FormContainer.defaultProps = { addedStyle: {}, onSubmit: () => undefined };
